module.exports = __webpack_public_path__ + "static/img/rs_js_1.91daec1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rs/rs_js_1.png
// module id = BRvI
// module chunks = 1